import React, { Component, useRef } from 'react';
import axios from '~/axios';
import { Button, Modal, Row, Spin, Switch, notification } from 'antd';
import JoditEditor from "jodit-react";

import { joditConfig, joditButtons } from '../components/settings/jodit';

export default class Settings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            originalMessageValue: '',
            messageValue: '',
            loadingMessage: true,
            // Contains settings recived from server
            settings: [],
            loadingSettings: true,
            // Settings UI
            registration_enabled: false,
        }
        this.handleMessageChange = this.handleMessageChange.bind(this);
        this.updateMessage = this.updateMessage.bind(this);
        this.handleSettingsChange = this.handleSettingsChange.bind(this);

    }

    componentDidMount() {
        // Get message which is a seperate API call
        this.setState({ loadingMessage: true });
        axios.get('/api/messages/1').then(({ data }) => {
            this.setState({ originalMessageValue: data.text, messageValue: data.text });
            this.setState({ loadingMessage: false });
        }).catch(error => {
            console.log(error);
            this.setState({ loadingMessage: false });
        })

        // Get all other settings
        this.setState({ loadingSettings: true });
        axios.get('/api/settings').then(({ data }) => {
            this.setState({ settings: data }, () => {
                this.updateSettingsUI();
            });
            this.setState({ loadingSettings: false });
        }).catch(error => {
            console.log(error);
            this.setState({ loadingSettings: false });
        })
    }

    updateMessage() {
        axios.put('/api/messages/1', { text: this.state.messageValue }).then(response => {
            Modal.success({
                title: 'Message Updated',
                content: 'The registration message was updated successfully.',
            });
        }).catch(error => {
            Modal.error({
                title: 'Something Went Wrong'
            });
        })
    }

    handleSettingsChange(settingName, newValue) {
        // console.log({ settingName, newValue });
        axios.post('/api/settings', { [settingName]: newValue }).then(({ data }) => {
            // console.log(data);
            this.setState({ settings: data }, () => {
                console.log(this.getSettingByName(settingName).value);
                this.updateSettingsUI();

                // Let user know the changes are live
                notification.open({
                    key: settingName,
                    message: this.getSettingByName(settingName).label + ' Updated',
                    description:
                        this.getSettingByName(settingName).label + " has been set to " + newValue,
                });
            });

        }).catch(error => {
            console.error(error);
        })
    }

    getSettingByName(name) {
        return this.state.settings.find(x => x.name === name);
    }

    updateSettingsUI() {
        this.setState({
            registration_enabled: this.getSettingByName('registration_enabled').value,
        });
    }

    handleMessageChange(value) {
        this.setState({ messageValue: value })
    }

    render() {

        return (
            <div className="container">
                <h1>Settings</h1>
                <Row>
                    <h2>Registration Message</h2>
                    <p>This message displays at the top of the registration page. If it is empty, it will not display
                        anything.</p>

                    <Row>
                        <Spin spinning={ this.state.loadingMessage }>
                            <JoditEditor
                                // ref={editor}
                                value={ this.state.originalMessageValue }
                                config={ joditConfig }
                                // tabIndex={1} // tabIndex of textarea
                                // onBlur={newContent => this.handleMessageChange(newContent)} // preferred to use only this option to update the content for performance reasons
                                onChange={ this.handleMessageChange }
                            />
                        </Spin>
                    </Row>
                    <Row type="flex" justify="end">
                        <Button type="primary" onClick={ this.updateMessage }>Save Message</Button>
                    </Row>
                </Row>
                <Row>
                    <Spin spinning={ this.state.loadingSettings }>
                        <h2>Allow Registration</h2>
                        <p>Enable / Disable public registration</p>
                        <Row>
                            <Switch checked={ this.state.registration_enabled }
                                    onClick={ checked => this.handleSettingsChange("registration_enabled", checked) }/>
                        </Row>
                    </Spin>
                </Row>
            </div>
        );
    }
}
